import { Box, Container, Grid, Typography, useTheme } from '@mui/material'
import React from 'react'
import { BucketURL } from '../../ApiSetup/Api'

const AboutUsCommon = ({ data }) => {
    const theme = useTheme()
    const bucketUrl = BucketURL || 'https://webitodevelopment.s3.ap-south-1.amazonaws.com/'
    
    if (!data) return null
    
    return (
        <Box sx={{ py: { lg: 8, md: 6, sm: 4, xs: 3 }, backgroundColor: '#f9f9f9' }}>
            <Container>
                <Grid container spacing={4} alignItems="center">
                    <Grid item xs={12} md={6}>
                        {data?.image && (
                            <Box
                                component="img"
                                src={bucketUrl + data.image}
                                alt="About Us"
                                sx={{
                                    width: '100%',
                                    borderRadius: '16px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
                                }}
                            />
                        )}
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography
                            variant="h4"
                            sx={{
                                color: theme.palette.primary.main,
                                fontWeight: 700,
                                mb: 2
                            }}
                        >
                            {data?.title || 'About Us'}
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: { lg: '16px', md: '14px', sm: '14px', xs: '13px' },
                                lineHeight: 1.8,
                                color: '#666'
                            }}
                            dangerouslySetInnerHTML={{ __html: data?.description || '' }}
                        />
                    </Grid>
                </Grid>
            </Container>
        </Box>
    )
}

export default AboutUsCommon
